import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import debounce from "lodash.debounce";

import { getMunicipalities, clearMunicipalityState, getMoreMunicipalities, setMunicipalityPage } from '../../store/actions/municipalityActions';
import { setMayorFilters } from '../../store/actions/mayorActions';

import DogHero from '../Global/DogHero';
import Filters from './Filters';
import MunicipalityCard from '../Global/MunicipalityCard';

import dog from '../../assets/images/product-dog.png';
import loader from '../../assets/animations/loader-b.svg';
import MobileOverlay from '../Global/MobileOverlay';
import { isMobile } from 'react-device-detect';

class MunicipalitiesPage extends Component {
  
    componentDidMount(){
        this.props.getMunicipalities();
        window.addEventListener('scroll', this.handleScroll, true)
    }
    componentWillUnmount(){
        this.props.clearMunicipalityState();
        window.removeEventListener('scroll', this.handleScroll, true);
    }
    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    }

    handleScroll = debounce(async () => {
        const wrappedElement = document.getElementById('municipalities');
            
            if (this.isBottom(wrappedElement) && this.props.totalMunicipalities && this.props.municipalitiesShown && this.props.totalMunicipalities !== this.props.municipalitiesShown) {
                await this.props.setMunicipalityPage(this.props.page + 1);
                this.props.getMoreMunicipalities(this.props.filters);
            }
    }, 200)

    render(){
        const { municipalities, fetchingMunicipalities, fetchingAdditionalMunicipalities, region } = this.props;

        return (
            <React.Fragment>
                {isMobile ? <MobileOverlay /> : null}
                <DogHero 
                id="municipalityHero" 
                inputHidden={true} 
                titleRight={`u Bosni i Hercegovini i saznajte više o njima!`} 
                titleHighlight={region ? (region === 'FB' ? `općina` : `opština`) : null} 
                dog={dog} 
                titleLeft={`Pretražite listu`} />
                <div id="municipalities" className="breeds">
                    <Filters />
                    <div className="results">
                        {fetchingMunicipalities ? <img src={loader} alt="loader" className="breeds__loading" /> : 
                        <React.Fragment>
                            {municipalities && municipalities.length ?
                                municipalities.map(municipality => {
                                    return <MunicipalityCard
                                        key={municipality._id}
                                        id={municipality._id}
                                        municipality={municipality}
                                        goToMunicipalityDetails={this.goToMunicipalityDetails}
                                        goToMayorsPage={this.goToMayorsPage}
                                        mayor={municipality.mayor}
                                        region={region} />
                                })
                                    : <h1>
                                        Ne postoje {region === 'FB' ? 'općine' : 'opštine'} koji odgovaraju filterima
                                    </h1>}
                                {fetchingAdditionalMunicipalities ? <img src={loader} alt="loader" className="breeds__loading--additional" /> : null}
                        </React.Fragment>}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    goToMunicipalityDetails = (event) => {
        this.props.history.push('/municipalities/' + event.target.name);
    }
    goToMayorsPage = async (event) => {
        const mayor = event.target.name;
        
        this.props.history.push(`/mayors/${mayor}`);
    }
}
const mapStateToProps = (state) => {
    return {
        municipalities: state.municipalities.municipalities,
        filters: state.municipalities.filters,
        fetchingMunicipalities: state.municipalities.fetchingMunicipalities,
        page: state.municipalities.page,
        totalMunicipalities: state.municipalities.totalMunicipalities,
        municipalitiesShown: state.municipalities.municipalitiesShown,
        dogFilters: state.mayors.filters,
        fetchingAdditionalMunicipalities: state.municipalities.fetchingAdditionalMunicipalities,
        region: state.common.region
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getMunicipalities: (filters) => { dispatch(getMunicipalities(filters)) },
        clearMunicipalityState: () => { dispatch(clearMunicipalityState()) },
        setMunicipalityPage: (page) => { dispatch(setMunicipalityPage(page)) },
        getMoreMunicipalities: (filters) => { dispatch(getMoreMunicipalities(filters)) },
        setMayorFilters: (filters) => { dispatch(setMayorFilters(filters)) }
    }
}
export default connect(mapStateToProps,mapDispatchToProps) (withRouter(MunicipalitiesPage));